import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { clearClip, setClip, setClipLength } from "../store";
import { ClipSelector } from "./ClipSelector";
import { Menu } from '@base-ui/react/menu';
import { MenuIcon } from "lucide-react";
import { useNoteGenerator } from "../hooks/useNoteGenerator";
import { factoryClips } from "../../assets/clips";
import { Dialog } from "primereact/dialog";


export const ClipControls = ({ className, instrument, showAutogenerate, hideLengthControls}) => {
    const dispatch = useDispatch();

    const clipNumber = useSelector(instrument.getDisplayParameterSelector("clipNumber"));
    const displayClipLength = useSelector(instrument.getDisplayClipLengthSelector());
    handleClipLengthUpdate = value => dispatch(setClipLength({instrumentID: instrument.id, clipNumber: clipNumber, value}));

    const factoryClipsForInstrument = factoryClips.filter(clip => clip._metadata.instrumentType === instrument.metadata.tipus);
    return (
        <fieldset className={`clip-controls flex gap-10 ${className}`}>
            <ClipMenu currentClipNumber={clipNumber} instrument={instrument} showAutogenerate={showAutogenerate} factoryClipsForInstrument={factoryClipsForInstrument}/>
            <ClipSelector instrument={instrument} buttonWidth="30px" />
            {!hideLengthControls &&
            <fieldset data-widget-id="clipDurationControls" className="length-controls"> {/* Min one bar (1*16), max four bars (4*16) */}
                <button className="btn w-30" disabled={displayClipLength <= 1*16} onClick={() => handleClipLengthUpdate(displayClipLength / 2)}>/2</button>
                <button className="btn w-30" disabled={displayClipLength >= 4*16} onClick={() => handleClipLengthUpdate(displayClipLength * 2)}>x2</button>
            </fieldset>}
        </fieldset>
    );
};

// very similar to presetmenu in presetbankbar
function ClipMenu({currentClipNumber, showAutogenerate, instrument, factoryClipsForInstrument}) {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoadDialogVisible, setIsLoadDialogVisible] = useState(false);
    const generate = showAutogenerate && useNoteGenerator({instrument})
    const currentClip = useSelector(instrument.getDisplayClipSelector());
    const clipType = currentClip.sequence ? "midi" : "audio";
    
    const isClipEmpty = (clipType === "midi" ? currentClip.sequence : Object.keys(currentClip.sound)).length === 0;
    const dispatch = useDispatch();
    const clear = () => dispatch(clearClip({instrumentID: instrument.id, clipNumber: currentClipNumber}));
    return <>
        <Menu.Root open={isOpen} onOpenChange={setIsOpen}>
            <Menu.Trigger className="btn btn-white w-30" data-widget-id="clipMenuTrigger">
                <MenuIcon />
            </Menu.Trigger>
           <Menu.Portal>
                <Menu.Positioner align="start">
                    <Menu.Popup className="menu">
                        <Menu.Item><button onClick={clear} disabled={isClipEmpty}>Esborra</button></Menu.Item>
                        {showAutogenerate && <Menu.Item><button onClick={generate}>Auto-genera</button></Menu.Item> }
                        {factoryClipsForInstrument.length > 0 && <Menu.Item onClick={() => setIsLoadDialogVisible(true)}><button>Carrega clip de fàbrica</button></Menu.Item>}
                    </Menu.Popup>
                </Menu.Positioner>
            </Menu.Portal>
        </Menu.Root>
        {factoryClipsForInstrument.length > 0 && <LoadClipDialog 
            isVisible={isLoadDialogVisible}
            setIsVisible={setIsLoadDialogVisible}
            clipNumber={currentClipNumber}
            factoryClipsForInstrument={factoryClipsForInstrument}
            instrumentID={instrument.id}
        />}
    </>
}

function LoadClipDialog({isVisible, setIsVisible, instrumentID, clipNumber, factoryClipsForInstrument, }) {
    const dispatch = useDispatch();
    function loadClip(clip) {
        dispatch(setClip({instrumentID, clipNumber, value: clip}));
        setIsVisible(false);
    }
    return <Dialog className="preset-save-dialog" visible={isVisible} onHide={()=>setIsVisible(false)} draggable={false} resizable={false}>
        <h2>Carrega un clip de fàbrica</h2>
        <ul className="menu">
            {factoryClipsForInstrument.map(clip => (
                <li><button onClick={() => loadClip(clip)}>{clip._metadata.name}</button></li>
            ))}
        </ul>
    </Dialog>
}